import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import Routes from 'Routes';
import { PAGE_NAMES } from 'appenv';

const SearchResultItemContainer = styled.div`
  margin: 24px 0;
  position: relative;
  border-bottom: 1px solid #DBDEE2;
`;

const StyledTitleContainer = styled.div`
  width: 80%;
  flex: 1;
`;

const StyledLink = styled(Link)`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  color: #484848;
`;

const StyledTag = styled.div`
  border-radius: 40px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  background: #FFF0E9;
  color: #E2654D;
  text-transform: captialize;
  padding: 5px 20.5px;
  height: min-content;
`;

const StyledSpeakers = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  color: #484848;
  margin-top: 16px;
`;

const StyledDetails = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #484848;
  margin: 17px 0 24px;
`;

const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const WebinarItem = ({
  id,
  name,
  details,
  speakers,
}) => (
  <SearchResultItemContainer>
    <ItemHeader>
      <StyledTitleContainer>
        <StyledLink to={`${Routes.webinar}/${id}`}>
          {name}
        </StyledLink>
      </StyledTitleContainer>
      <StyledTag>
        {PAGE_NAMES.webinar}
      </StyledTag>
    </ItemHeader>
    {speakers.length > 0 && (
      <StyledSpeakers>
        {`Speakers: ${speakers.map(({ name: speakerName }) => speakerName).join(', ')}`}
      </StyledSpeakers>
    )}
    <StyledDetails>
      {ReactHtmlParser(details)}
    </StyledDetails>
  </SearchResultItemContainer>
);

WebinarItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  details: PropTypes.string,
  speakers: PropTypes.arrayOf(PropTypes.shape()),
};

WebinarItem.defaultProps = {
  details: '',
  speakers: [],
};

export default WebinarItem;
